module.exports = __webpack_public_path__ + "static/media/covi_per_use_tis.1fe1e30c.png";